module.exports = __webpack_public_path__ + "static/media/background-login-tablet.e1e8b825.jpg";